module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add sticker-pic4.877506e8.jpg";